if (!customElements.get('custom-collection-grid')) {
  customElements.define(
    'custom-collection-grid',
    class CustomCollectionGrid extends HTMLElement {
      constructor() {
        super();

        this.productGridContainer = this.querySelector('#ProductGridContainer');
        this.sectionId - this.productGrid.dataset.id;
        // this.gridItems = this.querySelectorAll('.grid__item');

        // this.gridItems.forEach((gridItem) => gridItem.addEventListener('click', this.saveCookie));

        this.savedItems = [];
      }
      // saveCookie() {
      //   console.log(this);
      // }
      clearSavedItems() {
        this.savedItems = [];
      }
      reRenderGrid(newProductGridHTML) {
        this.clearSavedItems();
        this.productGridContainer.innerHTML = newProductGridHTML;
        //wishlistCollection.updateWishlistButtons();
      }
      get productGrid() {
        return this.querySelector('#product-grid');
      }
      addToGrid(newProductGrid, action = 'append') {
        if (newProductGrid.children.length) {
          let itemArray = Array.from(newProductGrid.children);
          if (action == 'prepend') {
            itemArray.reverse();
          }
          let outOfStockItems = [];
          let inStockItems = [];

          itemArray.forEach((item) => {
            let clone = item.cloneNode(true);
            if (`soldOut` in clone.dataset) {
              outOfStockItems.push(clone);
            } else {
              inStockItems.push(clone);
            }
          });

          this.savedItems.push(...outOfStockItems);

          if (inStockItems.length > 0) {
            inStockItems.forEach((child) => {
              let clonedChild = child.cloneNode(true);
              if (action == 'append') {
                this.productGrid.append(clonedChild);
              } else {
                this.productGrid.prepend(clonedChild);
              }
            });
          } else {
            this.addSavedItemsToGrid();
          }
        }
        //console.log('addtogrid');
      }
      addSavedItemsToGrid() {
        this.savedItems.forEach((item) => {
          this.productGrid.append(item);
        });
        //console.log('addsaveditemstogrid');
        this.clearSavedItems();
      }
    }
  );
}
